<template>
  <div class="content-wrapper safe-top">
    <div class="form form-middle">
      <div class="form-content-middle">
        <div class="img-container">
          <img src="@/assets/img/dialog/svg/dialog_alert.svg" alt="" />
        </div>
        <div>
          <div class="msg">
            <p>
              購入は完了しましたが、メールの送信時にエラーが生じました。購入内容のご確認や、領収書・明細書をご希望の場合は、EMotサポートセンターにお問い合わせください。
            </p>
          </div>
          <div class="foot-button-block">
            <div class="actions">
              <ItemButton
                label="お問い合わせページへ"
                action-type="btn-primary"
                @clicked="gotoInquiryPage()"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { onMounted, computed, watchEffect, ref } from "vue";
import { useStore } from "vuex";
import { useRoute, useRouter } from "vue-router";
import nativeHandlerService from "@/services/nativeHandler";

export default {
  name: "TemplateMfittBookingMailSentError",
  setup() {
    const store = useStore();
    const route = useRoute();
    const router = useRouter();
    // const specifyMethod = route.query.specifyMethod;

    const gotoInquiryPage = () => {
      if (process.env.NODE_ENV == "local") {
        router.push({
          name: "MfittIndex",
        });
      } else {
        nativeHandlerService.ncReturnNativeAppToContactUs();
      }
    };

    return {
      // specifyMethod,
      gotoInquiryPage,
    };
  },
};
</script>
<style scoped lang="scss">
.safe-top {
  margin-top: calc(30px + env(safe-area-inset-top, 30px) + 30px);
}

.msg {
  padding: 0 20px;
  font-size: 15px;
  text-align: left;
}

.img-container {
  text-align: center;
  padding-top: 200px;
}

.img-container img {
  height: 90px;
  width: 90px;
}

.form-middle {
  position: absolute;
  width: 100%;
  height: 50%;
}

.form-content-middle {
  position: absolute;
  width: 100%;
  bottom: 45px;
}
.foot-button-block {
  position: fixed;
  z-index: 99;
  width: 100%;
  bottom: 0;
  background-color: #fff;
}

.foot-button-block .actions {
  width: 90%;
  margin: auto;
}
</style>
